import React, { FC, useContext } from "react";
import Restricted from "@/consumer/restricted";
import PermissionContext from "@/context/permissionContext";

interface HeaderBarQuickActionsRestrictedWrapperProps {
  children: React.ReactNode;
  subdomain: string;
}
//shows all used permissions for an overview - not used within the code
// const PERMISSIONS = [
//   "frontend_view_trackedservice_headerbar",
//   "frontend_view_todo_creator",
//   "frontend_view_appointment_dashboard",
//   "frontend_view_document",
//   "frontend_view_quickaction_accident_report",
// ] as const;

const ADMIN_PERMISSIONS = [
  "frontend_view_trackedservice_headerbar",
  "frontend_view_todo_creator",
  "frontend_view_appointment_dashboard",
  "frontend_view_admin_documents",
];
const MANAGER_PERMISSIONS = ["frontend_view_quickaction_accident_report"];
const CUSTOMER_PERMISSIONS = ["frontend_view_quickaction_accident_report"];

const HeaderBarQuickActionsRestrictedWrapper: FC<
  HeaderBarQuickActionsRestrictedWrapperProps
> = ({ children, subdomain }) => {
  const { isAllowedTo } = useContext(PermissionContext);

  let relevantPermissions: string[] = [];
  if (subdomain === "admin") {
    relevantPermissions = ADMIN_PERMISSIONS;
  } else if (subdomain === "manage") {
    relevantPermissions = MANAGER_PERMISSIONS;
  } else if (subdomain === "portal") {
    relevantPermissions = CUSTOMER_PERMISSIONS;
  }

  const hasAnyPermission = relevantPermissions.some((perm) =>
    isAllowedTo(perm)
  );
  if (!hasAnyPermission) return null;

  const gate = { opened: false };
  return (
    <>
      {relevantPermissions.map((permission) => (
        <Restricted key={permission} permissionRequired={permission}>
          <RenderOnce gate={gate}>{children}</RenderOnce>
        </Restricted>
      ))}
    </>
  );
};

export default HeaderBarQuickActionsRestrictedWrapper;

// Helper function to render children only once
function RenderOnce({
  gate,
  children,
}: {
  gate: { opened: boolean };
  children: React.ReactNode;
}) {
  if (gate.opened) return null;
  gate.opened = true;
  return <>{children}</>;
}
